import { render, staticRenderFns } from "./ListSidedish.vue?vue&type=template&id=47ca96e6&"
import script from "./ListSidedish.vue?vue&type=script&lang=js&"
export * from "./ListSidedish.vue?vue&type=script&lang=js&"
import style0 from "./ListSidedish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports